import { render, staticRenderFns } from "./RegionButtons.vue?vue&type=template&id=18d93e20&scoped=true"
import script from "./RegionButtons.vue?vue&type=script&lang=js"
export * from "./RegionButtons.vue?vue&type=script&lang=js"
import style0 from "./RegionButtons.vue?vue&type=style&index=0&id=18d93e20&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d93e20",
  null
  
)

export default component.exports